import { render } from "./EditDay.vue?vue&type=template&id=4d151bc4"
import script from "./EditDay.vue?vue&type=script&lang=js"
export * from "./EditDay.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/mwon.net/gugar.mwon.net/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__